module.exports = __webpack_public_path__ + "static/media/rc-rcb-banner.4b60a073.png";